import { CSSProperties } from "react";
import ModalSymphony from "elements/ModalSymphony";
import useOnboardingV2, { OnboardingStep } from "Hooks/useOnboardingV2";
import useScreen from "Hooks/useScreen";
import { clsx, makeKey, styx } from "modules/Utils";
import PlatformStartButton from "pages/MarketingPage/Components/CreateNewCampaignModal/PlatformStartButton";
import Colors from "modules/Colors";
import Sty from "modules/Sty";
import { getWebsiteBuilderPath } from "Hooks/useWebsiteBuilder";
import useBrand, { BrandExistsState } from "Hooks/useBrand";
import { useHistory } from "react-router-dom";

interface GoalsModalProps {
    className?: string;
    isModal?: boolean;
}

const GoalsModal = ({
    className,
    isModal = true,
}: GoalsModalProps) => {
    const { mStyle } = useScreen();
    const {
        currentBrand,
    } = useBrand() as BrandExistsState
    const history = useHistory();
    const {
        showGoalsModal,
        setShowGoalsModal,
        setOnboardingStep,
        setSelectedGoalUrl
    } = useOnboardingV2();

    const websiteBuilderLinkInBio = getWebsiteBuilderPath(currentBrand.slug);

    const CREATE_SYMPHONY_ITEM_GOALS: {
        title: string;
        icon: string;
        description: string;
        color: string;
        onClick: () => void;
    }[] = [
            {
                title: 'Run Ads to Grow',
                icon: 'boostInstagramEngagementV2',
                description: 'Grow your streams and followers',
                color: Colors.campaignInstagram,
                onClick: () => {
                    setSelectedGoalUrl('') // NOTE: <CreateSymphonyItemModal /> is where this is set next
                    setOnboardingStep(OnboardingStep.CREATE_CAMPAIGN)
                },
            },
            {
                title: 'Build a Link in Bio',
                icon: 'musicSite',
                description: 'And so much more',
                color: Colors.campaignBlue,
                onClick: () => {
                    setSelectedGoalUrl(websiteBuilderLinkInBio)
                    history.push(websiteBuilderLinkInBio)
                    // setOnboardingStep(OnboardingStep.PAYWALL)
                },
            },
            {
                title: 'Create a Pre-save',
                icon: 'presaveSite',
                description: 'Forever saves at your fingertips',
                color: Colors.campaignGreen,
                onClick: () => {
                    setSelectedGoalUrl('/marketing/new/presave')
                    history.push('/marketing/new/presave')
                    // setOnboardingStep(OnboardingStep.PAYWALL)
                },
            },
        ]

    const handleGoalItemClick = (goal: typeof CREATE_SYMPHONY_ITEM_GOALS[number]) => {
        console.log('Selected goal:', goal);
        setShowGoalsModal(false);
        goal.onClick();
    };

    const createSymphonyItemContent = (
        <div className="createSymphonyItemModalContainer">
            <div
                className="createSymphonyItemModalPromotableItems"
                style={styx(
                    mStyle(sty, 'createSymphonyItemModalPromotableItems'),
                    !isModal && { borderRadius: 16 },
                )}
            >
                {CREATE_SYMPHONY_ITEM_GOALS.map((goal, index) => {
                    const {
                        title,
                        icon,
                        description,
                        color,
                    } = goal;

                    return (
                        <PlatformStartButton
                            key={makeKey('goal-item', color, index)}
                            className="platformStartButtonCreateNewCampaignModalV2"
                            onClick={() => handleGoalItemClick(goal)}
                            title={title}
                            description={description}
                            icon={icon}
                            fullWidth
                            size="large"
                            isBorder={false}
                            color={color}
                        />
                    )
                })}
            </div>
        </div>
    )

    if (!isModal) {
        return createSymphonyItemContent
    }

    return (
        <ModalSymphony
            className={clsx("createSymphonyItemModal", className)}
            isOpen={showGoalsModal}
            onClose={() => {
                setShowGoalsModal(false)
            }}
        >
            {createSymphonyItemContent}
        </ModalSymphony>
    )
}

const sty: Record<string, CSSProperties> = {
    createSymphonyItemModalContainer: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        padding: 24,
    },
    createSymphonyItemModalTitle: {
        fontSize: 24,
        fontWeight: 600,
        marginBottom: 16,
        textAlign: 'center',
    },
    oneClickCampaignSetupModalPromotableItems: {
        display: 'flex',
        flexDirection: 'column',
        gap: 12,
        width: '100%',
        overflowY: 'auto',
        padding: 8,
    },

    createSymphonyItemModalPromotableItems: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        width: '100%',
        backgroundColor: Colors.greyLight,
        boxShadow: Sty.boxShadowInset,
        padding: 16,
    }
}

export default GoalsModal;